import React, { useEffect, useState } from "react";
import { Box, Typography, useMediaQuery ,Skeleton} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";
import FeaturesHeroCard from "../../components/cards/FeaturesHeroCard";
import acc5_eng from "../../assets/acc5_eng.png"; // Adjust the path as necessary
import acc5_spa from "../../assets/acc5_spa.png"; //
import i18next from "i18next"; // Uncomment if you need to use i18next for language detection
import { BASE_URL } from "../../components/BASE_URL";
const PaymentsSection = () => {
    const { t ,i18n} = useTranslation();
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
 const [loadingPayments, setLoadingPayments] = useState(true);
  const [paymentsCardData, setPaymentsCardData] = useState(null);

  const parseFeatureNames = (list) => {
    try {
      const items = Array.isArray(list)
        ? list
        : list
          ? JSON.parse(list)
          : [];
      return items.map((f) => f.name);
    } catch {
      return [];
    }
  };

// Manage Payments
useEffect(() => {
  const fetchPayments = async () => {
    try {
      const res = await fetch(
        `${BASE_URL}content/sections?page=1&limit=10&sort=order&include=items&search=Manage_Payments`
      );
      const json = await res.json();
      if (!json.error && json.data?.length) {
        const section = json.data[0];
        const item =
          i18n.language === "es"
            ? section.items.find(it => it.idx === 1)
            : section.items.find(it => it.idx === 0);

        if (item) {
          setPaymentsCardData({
            title: item.title,
            description: item.description,
            features: parseFeatureNames(item.list),
          });
        }
      }
    } catch (err) {
      console.error("Error fetching Manage_Payments:", err);
    } finally {
      setLoadingPayments(false);
    }
  };

  fetchPayments();
}, [i18n.language]);

    return (
        <Box id="payments-section">
      {loadingPayments ? (
        <Box sx={{ p: 3 }}>
          <Skeleton variant="text" width={300} height={50} />
          <Skeleton variant="text" width={560} height={28} />
          <Skeleton variant="rectangular" width="100%" height={180} sx={{ mt: 2 }} />
        </Box>
      ) : (
        <FeaturesHeroCard
          bgColor="#EFF4F8"
          image={i18next.language === "es" ? acc5_spa : acc5_eng}
          imagePosition="left"
          title={paymentsCardData?.title}
          description={paymentsCardData?.description}
          features={paymentsCardData?.features}
        />
      )}
    </Box>
    );
};

export default PaymentsSection;


